/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SklikIntegrationInput
 */
export interface SklikIntegrationInput {
    /**
     * 
     * @type {string}
     * @memberof SklikIntegrationInput
     */
    apiKey?: string;
}

/**
 * Check if a given object implements the SklikIntegrationInput interface.
 */
export function instanceOfSklikIntegrationInput(value: object): value is SklikIntegrationInput {
    return true;
}

export function SklikIntegrationInputFromJSON(json: any): SklikIntegrationInput {
    return SklikIntegrationInputFromJSONTyped(json, false);
}

export function SklikIntegrationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): SklikIntegrationInput {
    if (json == null) {
        return json;
    }
    return {
        
        'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
    };
}

export function SklikIntegrationInputToJSON(json: any): SklikIntegrationInput {
    return SklikIntegrationInputToJSONTyped(json, false);
}

export function SklikIntegrationInputToJSONTyped(value?: SklikIntegrationInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'apiKey': value['apiKey'],
    };
}

